import { FileInfo } from ".";

/** Other fields, that are specified in swagger are not meant for frontend use */
export const mapUnsanitizedFileToFile = ({ id, name, mime, url, length, selfHostVideo, selfHostedStatus }: FileInfo): FileInfo => ({
  id,
  name,
  mime,
  url,
  length,
  selfHostVideo,
  selfHostedStatus,
});

/** Other fields, that are specified in swagger are not meant for frontend use */
export const mapUnsanitizedFilesToFiles = (files: FileInfo[]): FileInfo[] =>
  Array.isArray(files) ? files.map((file) => (file ? mapUnsanitizedFileToFile(file) : file)) : [];
